<template>
  <layout title="Contact Sales">
    <div class="relative pt-8 mx-auto max-w-4xl lg:pt-10 sm:px-12 px-4">
      <div class="relative mx-auto max-w-7xl">
        <div class="flex flex-col justify-start">
          <h1 class="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Contact Sales
          </h1>
          <p class="mt-3 text-xl leading-7 text-gray-500 sm:mt-4">
            Tell us a bit about your project and we will help you to find the right solution.
          </p>
        </div>
      </div>
    </div>
    <div class="flex justify-center w-full">
      <div class="w-full">
        <vue-calendly
          url="https://calendly.com/pt2020/talk-to-sales-yoonik/meet-and-greet-with-yoonik?embed_type=Inline&hide_gdpr_banner=1"
          :height="700"
        ></vue-calendly>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");

export default {
  components: {
    layout,
  },
};
</script>